import { BookingService } from './booking-service';
import { Client } from '../client/client';
import { ClientService, ClientPackage } from '../client/client-service';
import { Transactions } from '../transactions/transactions';
import { PaidStatus } from '../../enums/paid-status';
import { BookingOrTransactionPlace } from '../../enums/booking-or-transaction-place';
import { MyUser } from '../my-user/my-user';
import { Attachment } from '../transactions/attachment';
import { CustomCalendeValue } from '../../../shared/helpers';
import { BookingStatus } from '../../enums/booking-status';
import { BookingServiceClass } from '../../../dashboard/bookings/models/booking-service';
import { AddedByDevice } from '../../enums/added-by-device';
import { AddAndModfyUser } from '../my-user/add-and-modfy-user';
import { PaymentMethodModel } from './payment-method-model';
import { BookingInfoDTO } from './booking-info';
import { BookingForWorkDoneDTO } from './booking-for-work-done';
import { ApplicationType } from '../../enums/application-type';

export class Booking {
  constructor() {
    this.Id = 0;
  }
  public Id: number;
  public SlotId: number;
  public BookingStatus: BookingStatus;
  public ClientId: number;
  public Client: Client;
  public ClientAddress: ClientAddressDTO;
  public ClientAddressText: string;
  public OriginalBookingStatus: BookingStatus;
  public AddedByDevice: AddedByDevice;
  public Date: Date;
  public Time: string;
  public Comment: string;
  public BookingServices: BookingServiceClass[];
  public Attachments: Attachment[];
  public BookingServicesDetails: BookingService[];
  public ClientServices: ClientService[];
  public ClientPackages: ClientPackage[];
  public RequestPermissionNotificationId: number;
  public Transactions: Transactions[];
  public AccountSetupId: number;
  public IsPaid: PaidStatus;
  public TotalTime: number;
  public VisitNo: number;
  public ClassType: string;
  public AddedAppId: ApplicationType;
  public BookingPlace: BookingOrTransactionPlace;
  public BranchGlobalName: string;
  public UserName: string;
  //----not mapped
  public DateFormated: string;
  public TotalBookingPrice: number;
  public TotalDiscountValue: number;
  public TotalPayments: number;
  public SlotsNo: number;
  public EmployeeIdTmp: number;
  public CustomCalendeValue: CustomCalendeValue;
  public TotalAmount: number;
  public OnSameTime: boolean;
  public OnSameEmp: boolean;
  public CompanyId: number;
  public BookingForNextDay: boolean;

  public PaidAmount: number;

  public TotalPayedValue: number;

  public ClientNotificationOTPId: number;
  public BookingOTPCode: string;

  public TotalNetPrice: number;

  public EnablePayment: boolean;
  public BookingNotes: string;


  public RemainigAmount: number;

  public User: MyUser;

  public BookingPaymentMethods: PaymentMethodModel[];
  public BookingPaymentMethodsNames: string;
  public BookingPaymentMethodsNamesTitle: string;

  public BookingStatusDesc: string;

  public AddUser: AddAndModfyUser;

  public AddedDate: Date;

  public BookingInfo: BookingInfoDTO;
  public BookingForWorkDone: BookingForWorkDoneDTO;

  public LoadingGetBooking: boolean;
}

export const BookingStatusConst = {
  Canceled: -1,
};



export interface ClientAddressDTO {
  Id: number;
  ClientId: number;
  Location: string;
  Street: string;
  BuildingNo: string;
  FloorNo: string;
  ApartmentNo: string;
  Mobile: string;
  Status: number;
  Latitude: number;
  Longitude: number;
  ZoneId: number | null;
  ZoneName: string;
  Area: string;
  Label: string;
}
